import { EnumBase } from 'hay-core-react';
class HomologacaoIntegracaoObrigatoriedadeSecretEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.homologacaointegracao.obrigatoriedadesecret.desativado',
                'main.homologacaointegracao.obrigatoriedadesecret.opcional',
                'main.homologacaointegracao.obrigatoriedadesecret.obrigatorio',
            ],
            'main.homologacaointegracao.obrigatoriedadesecret.obrigatorio'
        );
    }
}

const instance = new HomologacaoIntegracaoObrigatoriedadeSecretEnum();
export default instance;
